import { getSessionUUID } from '../components/lib/AuthToken';


const request = async (path, options = {}) => {
    const sessionToken = await getSessionUUID();
    const response = await fetch(`/driver-bonus${path}`, {
        ...options,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${sessionToken}`,
            ...(options.headers || {}),
        },
    });
    const data = await response.json();
    if (!response.ok) {
        throw new Error(data.error || 'Driver bonus request failed');
    }
    return data;
};


export const getDriverBonusDashboard = () => request('/dashboard');

export const saveDriverBonusConfig = (config) => request('/config', {
    method: 'PUT',
    body: JSON.stringify(config),
});

export const evaluateDriverBonus = () => request('/evaluate', { method: 'POST' });

export const addDriverBonusAdjustment = (adjustment) => request('/events/manual', {
    method: 'POST',
    body: JSON.stringify(adjustment),
});

export const reviewDriverBonusEvent = (eventId, decision, reason) => request(`/events/${eventId}/review`, {
    method: 'POST',
    body: JSON.stringify({ decision, reason }),
});

export const overrideDriverBonusEvent = (eventId, reason) => request(`/events/${eventId}/override`, {
    method: 'POST',
    body: JSON.stringify({ reason }),
});